export const giftCodeStorageKey = 'gift-code'
